import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=fde5368a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=fde5368a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde5368a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fde5368a')) {
      api.createRecord('fde5368a', component.options)
    } else {
      api.reload('fde5368a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=fde5368a&scoped=true&", function () {
      api.rerender('fde5368a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B94e5pSPe1yx/JS/comp/DocBox.vue"
export default component.exports